'use strict';

import LoginController from './login.controller';

export default angular.module('leafApp.login', [])
  .controller('LoginController', LoginController)
  .name;
